export default __webpack_public_path__ + "static/media/level_star_01_inactive.f88bb606.svg";